// Auto-extracted from translations.js — Zitro Property Management i18n
const en = {
  nav: {
    about: "About",
    protocol: "The Method",
    services: "Services",
    concierge: "Concierge",
    portfolio: "Portfolio",
    blog: "Blog",
    insights: "Insights",
    contact: "Contact",
    cta: "Let's talk",
  },
  hero: {
    overline: "Zitro — Property Management · Based in Como, on the territory",
    line1: "One proven method.",
    line2: "Every estate,",
    line3: "cared for",
    line3Accent: "as if it were the only one.",
    subtitle:
      "We are of Como and we are on the territory. Every property is followed by a local team that knows Lake Como as its own home — reachable within certain times, physically present on every estate we manage. A proven operating model behind the scenes, a human and discreet presence in front. Because on Lake Como, the details make the difference — and details are seen and lived every day.",
    ctaPrimary: "Tell us about your estate",
    ctaSecondary: "Discover the method",
    scroll: "Scroll",
  },
  marquee: [],
  about: {
    overline: "01 — About",
    title: "We don't manage properties.\nWe safeguard their value.",
    lead:
      "Every property holds an identity, a story and a potential that deserve to be preserved. Zitro was founded to offer premier estates on Lake Como an evolved management — attentive both to performance and to the protection of their value over time. A bespoke approach, supported by rigorous processes, specialised expertise and constant care for every detail. Because managing means taking care of the present. Safeguarding means building value over time.",
    chapters: [
      {
        n: "01",
        title: "Total attention",
        body: "Every property is a one-off, and we treat it as such. Architecture, history, staff, guests, owner's goals: nothing is ever generalised. Every operational choice starts from listening to the single estate — as if it were the only one we look after.",
      },
      {
        n: "02",
        title: "Proven method",
        body: "Total attention is not improvisation. Behind every action there's an operating model refined over years on Lake Como: documented procedures, dedicated roles, continuous quality checks. The solid structure that lets us be bespoke without ever being fragile.",
      },
      {
        n: "03",
        title: "Owner's peace of mind",
        body: "Punctual communication, clear reports, traceable decisions, always motivated expenses. Zero grey areas. Maximise returns without worry — while you go back to living what you own.",
      },
      {
        n: "04",
        title: "Guest care",
        body: "Every guest is selected, verified and welcomed in person by our qualified staff. Signed contract, credit-card guarantee, dedicated third-party liability policy always active. The safety of the estate is our first form of respect.",
      },
    ],
  },
  protocol: {
    overline: "02 — The Zitro Method",
    title: "A rigorous method.\nCare without compromise.",
    lead:
      "The Zitro Method unites strategy, organisation and control at every stage of management. Defined procedures, clear responsibilities and constant checks allow us to follow every property with precision, continuity and genuine attention. We don't standardise the properties: we standardise the quality of care we give them. Because every property is different — but the level of excellence cannot be.",
    roles: [
      { n: "01", label: "Control", title: "Standards verified\nat every stay", body: "A dedicated quality lead verifies every procedure on your property. Tracked inspections, measurable standards, non-conformities corrected in real time. The result is a property always at its best — even when you're not there." },
      { n: "02", label: "Assistance", title: "One point of contact,\nzero bouncing", body: "Dedicated customer service for you and your guests, reachable every day. No call centre, the same voice always. Requests are resolved before they become problems, with punctual reports and orderly communication." },
      { n: "03", label: "Care", title: "Predictive maintenance,\nvalue that grows", body: "In-house team for historic villas and contemporary residences, local craftsmen activatable within 24 hours. Plans built around the property — never off a catalogue. Every action leaves the estate a little more precious than we found it." },
      { n: "04", label: "Housekeeping", title: "Every check-in\nis a debut", body: "Silent turn-overs, photographic inspections after every guest, care for textiles, art collections and delicate furnishings. Staff trained on luxury hospitality protocols. Your home welcomes guests as if you were expecting them yourself." },
      { n: "05", label: "Performance", title: "Net revenue,\nnot occupancy", body: "Dedicated revenue manager, pricing updated every day reading market, seasonality and events. Quarterly analyses, documented benchmarks, traceable decisions. The goal isn't filling the calendar: it's maximising the net of your single property." },
    ],
  },
  services: {
    overline: "03 — Services",
    title: "One point of contact.\nOne complete system.",
    lead:
      "Every property is followed through a precise organisational model, built on its own characteristics and on the owner's needs. Skills, activities and responsibilities are coordinated within a single management system.",
    items: [
      { k: "SVC 01", title: "Integrated Management", body: "An operational direction built around the property: coordination of staff, maintenance, supplies, security and administrative duties. One point of contact supervises every activity, ensuring continuity and control." },
      { k: "SVC 02", title: "Revenue & Distribution", body: "Dynamic pricing strategies, continuous demand analysis and distribution on the channels most consistent with the property's positioning. We optimise profitability and booking quality without compromising perceived value." },
      { k: "SVC 03", title: "Concierge & Hospitality", body: "Bespoke experiences and services, coordinated through a curated network of professionals and local partners. Every request is handled with discretion, precision and attention to the guest's preferences." },
      { k: "SVC 04", title: "Projects & Value Creation", body: "We coordinate architects, contractors and selected craftsmen for improvement and refurbishment works. We oversee timing, costs and execution quality, protecting the identity of the property." },
      { k: "SVC 05", title: "Property Advisory", body: "We analyse performance, costs and potential of the estate to support more informed decisions. Periodic reports and forward-looking scenarios deliver a clear view of results and future opportunities." },
      { k: "SVC 06", title: "Interior & Styling", body: "We take care of the property's image through styling, refresh of spaces and preparation for shootings and stays. Every choice enhances spaces, materials and identity — improving presentation and experience." },
      { k: "SVC 07", title: "Tax Strategy", body: "Zitro implements a strategic tax-management framework, built together with accountants specialised in luxury real estate. It unlocks tax advantages of up to 40% on rental income — for private owners as well as companies — combining flat-rate regimes, depreciation, deductions and corporate structuring aligned with the estate." },
    ],
  },
  cinematic: {
    overline: "Lake Como · The experience",
    title: "Details\nmake the difference.",
    body:
      "True luxury is not objects — it's the experience of a holiday designed in every gesture. The rhythm of the days, the right silence at the right moment, timings respected, the feeling of being home in a place you've never seen before. We design the experience, not the appearance — because a stay on Lake Como becomes memory only when every invisible detail is in its place.",
  },
  portfolio: {
    overline: "04 — Portfolio",
    title: "Selection.\nNot collection.",
    subtitle:
      "We manage a deliberately limited number of assets. Each estate receives a unique value-creation plan and total attention — because true bespoke service can't scale infinitely, and shouldn't.",
    viewAll: "Full portfolio",
  },
  caseStudy: {
    overline: "05 — Case Study",
    title: "Superior earnings,\ndocumented results.",
    lead:
      "With Zitro we don't tell stories — we measure. Every property under our custody generates objective KPIs, tracked month by month and certified quarterly. No personal feelings: only data that prove that under Zitro management, estates earn more.",
    docBadge: "Every KPI is documented and audited — quarterly audit trail available to the owner",
    property: {
      name: "Regina 35 — Carate Urio",
      typology: "180 sqm · 3 bedrooms · 3 bathrooms",
      cover: "https://customer-assets-jai6qajn.emergentagent.net/job_como-properties/artifacts/2khprcdp_Carate%20Urio-35%20%281%29.webp",
    },
    challenge: {
      label: "The context — before Zitro",
      title: "An underperforming property,\nwithout data.",
      body: "Generalist management, static pricing set once a year, unselected guests, reactive maintenance only after failure. Annual email reports, no decision traceability, no comparison against market benchmarks.",
    },
    approach: {
      label: "The Zitro method — twelve months later",
      title: "One direction, continuous measurement,\npresence on the territory.",
      body: "Local team active within 20 minutes of the property, revenue manager with pricing updated every day on real-time market data, tracked guest selection protocols, predictive maintenance plan. Every decision recorded, every euro justified in an audit-ready quarterly report.",
    },
    metricsHeader: "12 months of Zitro management. Verified numbers.",
    metrics: [
      { k: "+34%", label: "Owner net revenue", note: "Vs. previous 12 months · source: certified quarterly statement" },
      { k: "+22%", label: "Average ADR (€/night)", note: "Dynamic pricing, Airdna data + direct benchmarks" },
      { k: "+18 pp", label: "Occupancy rate", note: "From 47% to 65% · tracked Zitro calendars" },
      { k: "9.6/10", label: "Average guest rating", note: "Across 78 verified reviews (Airbnb, Booking, direct)" },
      { k: "0", label: "Unresolved emergencies >2h", note: "Local team SLA log · 24/7 availability" },
      { k: "100%", label: "Tracked interventions", note: "Every ticket signed, before/after photos, owner report" },
    ],
    quote:
      "Before, I received generic reports and no one told me why a decision had been taken. With Zitro every euro is justified, every choice has a number behind it. And the numbers speak: today the villa earns a third more, without me having to think about it.",
    quoteAuthor: "Owner, Regina 35",
    cta: "Request an analysis like this for your property",
  },
  testimonials: {
    overline: "06 — Trust",
    title: "Trust is built\nover time.",
  },
  insights: {
    overline: "06 — Zitro Letters",
    title: "The Zitro\nLetters.",
    lead: "One letter a month on hospitality, property and culture of Lake Como. Slow thoughts, straight to your inbox.",
    readMore: "Read",
  },
  newsletter: {
    overline: "Newsletter · Zitro Letters",
    title: "Slow thoughts,\nstraight to your inbox.",
    lead: "One letter a month on management, culture and market of Lake Como. Only curated writing — never spam, never noise.",
    placeholder: "Your email address",
    submit: "Subscribe",
    success: "Thank you. We'll be in touch soon.",
    error: "Something went wrong. Please retry.",
    disclaimer: "Used only to send the newsletter. No sharing with third parties.",
    viewAll: "All articles",
  },
  contact: {
    overline: "07 — Contact",
    title: "Let's talk.",
    subtitle:
      "The best collaborations are born from confidential conversations. Tell us about your estate: let's start building a bespoke value-creation plan together.",
    form: {
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      type: "Asset type",
      message: "How can we help?",
      submit: "Send request",
      sending: "Sending…",
      success: "Thank you. We'll reply within 24 hours.",
      error: "Something went wrong. Please retry.",
      consentRequired: "You must accept the privacy policy to proceed.",
      options: ["Private villa", "Historical residence", "Penthouse", "Palace", "Restoration project", "Other"],
    },
    infoTitle: "Contacts",
    infoAddress: "Via Cinque Giornate 76/L\nCernobbio (CO) — Italy",
    infoEmail: "info@zitroapartments.com",
    infoPhone: "+39 375 7410 999",
    infoWebsite: "www.zitroapartments.com",
    whatsapp: "Message us on WhatsApp",
    whatsappMsg: "Hello, I have a property on Lake Como and would like to request information",
  },
  footer: {
    claim: "The Zitro Method — Property Management on Lake Como",
    motto: "Details, by design.",
    rights: "All rights reserved.",
    lang: "Language",
  },
  audiences: {
    overline: "Who we serve",
    title: "One method,\nthree audiences.",
    lead:
      "Zitro speaks the language of those who understand the value of an estate — and expect management to match. Whether a private owner, a holding company or a professional representing a client, the method is the same: total care, discretion, measurable results.",
    items: [
      {
        k: "01",
        title: "Owners",
        body: "For those who own a fine estate and want a partner who safeguards it as they would themselves. Maximise revenue, keep peace of mind, come back to living the home without operational worries. One point of contact, decisions always shared.",
      },
      {
        k: "02",
        title: "Companies",
        body: "For family offices, real-estate holdings and corporate entities that want to turn assets into measurable performance. Quarterly reports, tax optimisation, holding strategies, documented exit strategy. Clear numbers, traceable decisions.",
      },
      {
        k: "03",
        title: "Professionals",
        body: "For notaries, lawyers, wealth advisors and trusted brokers seeking a reliable manager for their most discerning clients. Our discretion becomes an extension of your professionalism — always confidential, always aligned.",
      },
    ],
  },
  partners: {
    overline: "Certifications & Recognitions",
    title: "Accredited.\nRecognised.\nAwarded.",
    lead:
      "Zitro operates by verifiable standards, recognised at European level, in partnership with the most prestigious operators of luxury real estate. Our properties are recognised by the leading market platforms for the quality of the hospitality we deliver.",
    items: [
      { label: "Airbnb Recognition", name: "Superhost", body: "Airbnb Superhost recognition: our properties maintain a response rate above 90%, average rating over 4.8 stars and near-zero cancellations. A status re-confirmed quarter after quarter." },
      { label: "Booking.com Award", name: "Traveller Review Award", body: "Booking.com Traveller Review Award — assigned to hosts with consistently excellent guest reviews (average rating ≥ 8.5). A public, verifiable recognition of our service quality." },
      { label: "European Certified Partnership", name: "Luxforsale", body: "Luxforsale certified partner at European level — the reference network for luxury property management. A direct channel to family offices, Ultra HNWI and the most demanding international clientele of premier real estate." },
      { label: "Industry Association", name: "AIGAB", body: "Members of the Italian Short-Term Rental Managers Association. We contribute to defining best practices and operational standards of the Italian sector." },
    ],
  },
  simulator: {
    overline: "Revenue Simulator",
    title: "One model.\nOne order of magnitude.",
    lead:
      "An indicative tool built on aggregated Airdna data for the Lake Como market. Estimates are conservative and reflect a typical owner net after commissions, operating costs and taxes. The pricing model we actually apply to your property is bespoke — contact us for a precise analysis.",
    typeLabel: "Property type",
    types: [
      { key: "attico", label: "Penthouse / Apartment", adr: 620 },
      { key: "dimora", label: "Historical residence", adr: 950 },
      { key: "villa", label: "Lakefront villa", adr: 1400 },
      { key: "palazzo", label: "Palace / Estate", adr: 2100 },
    ],
    locationLabel: "Location",
    locations: [
      { key: "prime", label: "Bellagio · Cernobbio · Tremezzina", mult: 1.28 },
      { key: "standard", label: "Como · Menaggio · Lenno", mult: 1.0 },
      { key: "emerging", label: "Varenna · Blevio · other", mult: 0.82 },
    ],
    surfaceLabel: "Surface",
    surfaceUnit: "sqm",
    bedroomsLabel: "Bedrooms",
    seasonLabel: "Rental mode",
    seasons: [
      { key: "shortterm", label: "Short-term luxury (weeks)", occ: 0.42, adrMult: 1.0 },
      { key: "mixed", label: "Strategic mix (short + mid-term)", occ: 0.66, adrMult: 0.74 },
    ],
    results: {
      adr: "Average ADR",
      nights: "Nights booked/year",
      gross: "Annual gross revenue",
      net: "Estimated owner net",
      note: "Indicative estimate built on aggregated data. The real pricing we'll apply to your property starts from the same model but is calibrated every day by the revenue manager dedicated to the estate — nothing left to intuition, only process.",
    },
    cta: "Request personalised analysis",
  },
  concierge: {
    overline: "Zitro Concierge",
    hero1: "Every wish,",
    hero2: "before it's",
    hero3: "expressed.",
    lead:
      "Our concierge doesn't respond: it anticipates. One point of contact, one ecosystem of selected partners across Lake Como, Milan and Northern Italy. Helicopter, yacht, Michelin chefs, sommeliers, private guides, vintage cars, in-villa wellness. Every experience is designed around the guest and the estate and followed by verification procedures: never improvised, never off-catalogue.",
    backToHome: "Back to home",
    ctaTitle: "Imagine something.\nWe organise it.",
    ctaBody:
      "Every experience is designed by the property's Quality Manager, verified by the dedicated Customer Service and certified before delivery.",
    ctaButton: "Contact us",
    services: [
      { k: "01", title: "Private Helicopter", body: "Transfer from Milan Linate/Malpensa or Bergamo Orio directly to the property's helipad. Scenic flights over Lake Como, the Alps and the Lombard lakes. AOC certified partner.", img: "https://images.unsplash.com/photo-1558597576-f1a962543f35" },
      { k: "02", title: "Yacht & Classic Motorboats", body: "Vintage Riva Aquarama, luxury tenders, private yachts for day trips or multi-day cruises. Certified skippers, pickup from the property's private mooring.", img: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a" },
      { k: "03", title: "Michelin Chef in Villa", body: "Private dinners by Michelin chefs, multi-hand tastings, exclusive cooking classes. Menus designed on preferences, allergies and occasions.", img: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0" },
      { k: "04", title: "Private Sommelier", body: "Vertical tastings of great vintages, evening tastings on the terrace, exclusive access to Franciacorta, Bergamo Hills and Valtellina cellars.", img: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3" },
      { k: "05", title: "Drivers & Vintage Cars", body: "Fleet with bilingual drivers, luxury vehicles and a collection of historic cars — from classic saloons to vintage sports cars — for shootings, weddings and panoramic Lake Como tours.", img: "https://images.unsplash.com/photo-1566238432098-35fc2fa3d908" },
      { k: "06", title: "Security & Bodyguard", body: "Discreet security personnel, certified close protection, access management during private events and extended stays.", img: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b" },
      { k: "07", title: "Wellness & Private SPA", body: "In-villa massages, personal trainer, sunrise yoga on the dock, aesthetic doctor and osteopath on request. A retreat without leaving home.", img: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874" },
      { k: "08", title: "Cultural Experiences", body: "Private openings of Villa del Balbianello and Villa Carlotta, art guides, tours of historic Lake Como villas, access to ateliers and private collectors.", img: "https://images.unsplash.com/photo-1533105079780-92b9be482077" },
      { k: "09", title: "VIP Restaurant Access", body: "Reserved bookings at Michelin-starred restaurants across Lake Como and Milan. Last-minute tables, custom menus, transfer coordinated by staff.", img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4" },
      { k: "10", title: "Private Jet", body: "Discreet flights for rapid transfers across Europe. Main airports and private strips, absolute confidentiality, transfer coordinated to and from the estate.", img: "https://images.unsplash.com/photo-1540962351504-03099e0a754b" },
    ],
  },
};

export default en;
